const index = function (customerId) {
    return window.axios.get(`/api/customers/${customerId}/products`);
};

const create = function (customerId, data) {
    return window.axios.post(`/api/customers/${customerId}/products`, data);
};

const update = function (customerId, customerProductId, data) {
    return window.axios.put(`/api/customers/${customerId}/products/${customerProductId}`, data);
};

const destroy = function (customerId, customerProductId) {
    return window.axios.delete(`/api/customers/${customerId}/products/${customerProductId}`);
};

export default {
    index,
    create,
    update,
    destroy,
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/CustomerProductService.js